import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '@shared/configs/config';
import { parseApiDate } from '@shared/helpers/date-format.helper';

@Pipe({ name: 'dateTimeFormat', pure: true })
export class DateTimeFormatPipe implements PipeTransform {
  transform(value: string, format = Config.DATETIME_FORMAT_DOTS): string {
    const parsedDate = parseApiDate(value);
    return parsedDate ? parsedDate.format(format) : '';
  }
}
